export default __webpack_public_path__ + "static/media/subscription.ca63eed4.png";